<template>
    <div v-if="timeSlots.length">
        <CRow
        ><CCol tag="label" class="col-form-label">Временные слоты</CCol></CRow
        >
        <div>
            <CRow
                v-for="(slot, index) of timeSlots"
                :key="index"
            >
                <CRow class="mb-2 ml-2">
                    <CCol>
                        <p>
                            С <b>{{ slot.start_at }}</b> До <b>{{ slot.end_at }}</b> время доставки: 
                            <b>{{ slot.deliveri_time }}</b> <b v-if="slot.max_delivery_time">- {{ slot.max_delivery_time }}</b> (чч:мм).
                            <span v-if="slot.temp">{{ getTimeRemaining(slot.created_at) }}</span>
                            <span v-if="slot.day_of_week !== null">День недели: <b>{{ getTitleDayOfWeek(slot.day_of_week) }}</b></span>
                        </p>
                    </CCol>
                </CRow>
            </CRow>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import countdown from 'countdown';
    import { DAYS_OF_THE_WEEK  } from '../utils/time-slots';

    export default {
        props: {
            timeSlots: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({
            daysOfTheWeek: DAYS_OF_THE_WEEK,
        }),

        methods: {
            getTitleDayOfWeek(dayWeek) {
                let countDay = 0;
                const slotsOptions = [];

                this.daysOfTheWeek.forEach(day => {
                    slotsOptions.push({
                        value: countDay,
                        label: day
                    });
                    countDay += 1;
                });
                for (const slot of slotsOptions) {
                    if(dayWeek === slot.value){
                        return slot.label;
                    }
                }
                return '';
            },
            getTimeRemaining(date) {
                const dt = new moment(date).add(1, 'days');
                let theDate = new Date();
                let { hours = 0 } = countdown(theDate, new Date(dt.toDate()), countdown.HOURS);
                return `(осталось ${hours}ч.)`;
            }
        }
    };
</script>
